import { render, staticRenderFns } from "./inspectdata.vue?vue&type=template&id=03ff3132&scoped=true"
import script from "./inspectdata.vue?vue&type=script&lang=js"
export * from "./inspectdata.vue?vue&type=script&lang=js"
import style0 from "./inspectdata.vue?vue&type=style&index=0&id=03ff3132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff3132",
  null
  
)

export default component.exports